export const PHRASES = [
  "Your moma would be so proud",
  "This is the turning point of your culinary career",
  "No more boring pasta and sauce",
];
